import SettingsTeam from '@/features/settings/team'
import { useAuthStore } from '@/stores/auth.store'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/settings/team')({
  component: SettingsTeam,
  beforeLoad: () => {
    const authStore = useAuthStore.getState()
    const hasFullTeamAccess = authStore.getHasFullTeamAccess()

    if (!hasFullTeamAccess) {
      throw redirect({
        to: '/',
      })
    }
  },
})
